<!--
카피 컴포넌트
-------------------
크기는 em 으로 작성되어있기때문에 부모요소의 크기를 자동으로 따라감

예)
<copy class="ml-2" tooltip="운송장 복사하기" copy-text="운송장번호"></copy>
<copy class="ml-2 text-red font-size-2rem"></copy>
-->
<template>
    <i class="copy material-icons"
       :uk-tooltip="tooltip"
       @click="copy">
        content_copy
    </i>
</template>

<script>
export default {
    props: {
        tooltip: {
            type: String,
            default: '복사하기',
        },
        copyText: {
            type: String,
            default: null,
        },
    },
    data: function () {
        return {};
    },
    computed: {},
    methods: {
        /**
         * 복사
         */
        copy() {
            navigator.clipboard.writeText(this.copyText)
                .then(() => {
                    /*
                    UIkit.notification({
                        message: '<div><span uk-icon=\'icon: check\'></span>Copied!<br />' + this.copyText + '</div>',
                        status: 'copied-toast',
                        pos: 'top-center',
                    })

                     */
                    //console.log("클립보드에 복사되었습니다!");
                })
                .catch(err => {
                    //console.error("복사 실패:", err);
                });
        }

    },
}
</script>

<style lang="scss" scoped>
i.copy.material-icons {

    display: inline-block;

    font-size: 1.25rem;
    color: #428bca;

    vertical-align: middle;

    cursor: pointer;
}

</style>